import React, { useState, useEffect } from 'react';
import apiService from '../../../Auth/apiService';
import { useNavigate, NavLink } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Container, ButtonGroup } from 'react-bootstrap';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import MenuAdministrativos from './MenuAdministrativos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';
import { FaSearch } from 'react-icons/fa';
import CustomInput from '../../Utils/CustomInput';

export default function InformeAlberguesIngreso(){
    const { token, rol } = useAuth();
    const navigate = useNavigate();
    const fecha = new Date();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    
    const { control, handleSubmit, watch, formState: { errors }} = useForm({
        defaultValues: { 
            FechaInicial: fecha, 
            FechaFinal: fecha
        }
    });
    const [swalProps, setSwalProps] = useState();
    
    async function onSubmit(data) {
        await fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'), 
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    }

    async function fetchData(FechaI, FechaF) {
        setCargando(true);
        const url = `/caracterizacion/informes/ingresosalbergue?FechaInicio=${FechaI}&FechaFinal=${FechaF}`;        
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            if (result && result.length > 0) {
                setDatos(result);
            } else {
                setDatos([]);
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            }
            
        } catch (error) {
            if (error.response?.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de ingresos a albergues.',
                    showConfirmButton: true,
                });
            }
        } finally {
            setCargando(false);
        }
    }
    
    async function exportaExcel() {
        try {
            const xlsxMod = await import('xlsx');
            const XLSX = xlsxMod?.default ?? xlsxMod;
            const headers = [
                'Tipo documento', 'Identificacion', 'Primer Nombre', 'Segundo Nombre',
                'Primer Apellido','Segundo Apellido','Fecha Nacimiento','Sexo','Orientación Sexual',
                'Identidad de Género','Etnia','Discapacidad','Hecho Victimizante','Habitante Calle',
                'Campesino','Escolaridad','Régimen Afiliación Salud','Estrato Socioeconómico','Cantidad',
                'Zona','Área','Barrio','Comuna','Fecha Ingreso Programa','Fecha Salida Programa',
                'País Nacimiento','Cabeza de Familia','Parentesco'
            ];

            // Map data to match header order
            const wsData = filteredData.map(row => {
                let fechaNacimiento = row.FECHANACIMIENTO;
                if (Array.isArray(fechaNacimiento) && fechaNacimiento.length > 0) {
                    fechaNacimiento = fechaNacimiento[0];
                }
                if (fechaNacimiento && !Number.isNaN(Date.parse(fechaNacimiento))) {
                    const dateObj = new Date(fechaNacimiento);
                    fechaNacimiento = (dateObj - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                }
                return [
                    row.TIPODOCUMENTO,
                    row.DOCUMENTO,
                    row.PRIMERNOMBRE,
                    row.SEGUNDONOMBRE,
                    row.PRIMERAPELLIDO,
                    row.SEGUNDOAPELLIDO,
                    fechaNacimiento,
                    row.SEXO,
                    row.ORIENTACIONSEXUAL,
                    row.IDENTIDADGENERO,
                    row.ETNIA,
                    row.DISCAPACIDAD,
                    row.HECHOVICTIMIZANTE,
                    row.HABITANTECALLE,
                    row.CAMPESINO,
                    row.ESCOLARIDAD,
                    row.REGIMENAFILIACIONSALUD,
                    row.ESTRATOSOCIOECONOMICO,
                    row.det_cantidad,
                    row.ZONA,
                    row.AREA,
                    row.BARRIO,
                    row.COMUNA,
                    row.FECHAINGRESOPROGRAMA,
                    row.FECHASALIDAPROGRAMA,
                    row.PAISNACIMIENTO,
                    row.CABEZAFAMILIA,
                    row.PARENTESCO
                ];
            });

            // Add header row
            wsData.unshift(headers);

            // Create worksheet from array of arrays
            const ws = XLSX.utils.aoa_to_sheet(wsData);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'EstadisticosAlbergues');
            const date = new Date();
            await XLSX.writeFile(wb, `EstadisticosAlbergues_${date.toLocaleDateString('co-CO')}.xlsx`);
        } catch (error) {
            console.error('Error exporting excel:', error);
        }
    }

    async function exportarCSV() {
        setCargando(true);
        const FechaI = watch('FechaInicial').toLocaleDateString('en-CA')
        const FechaF = watch('FechaFinal').toLocaleDateString('en-CA')
        const url = `/caracterizacion/informes/ingresosalbergue?FechaInicio=${FechaI}&FechaFinal=${FechaF}&csv=${true}`;

        
        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            const currentDate = new Date().toLocaleDateString('co-CO');
            link.setAttribute('download', `EstadisticosAlbergues_${currentDate}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    useEffect(() => {
        if (rol !== '2') {
          navigate('/dashboard');
        }
      }, [rol, navigate]);
    const [filters, setFilters] = useState({
        SEXO: '',
    });
    // Filtrado de datos
    const filteredData = datos.filter(row =>
        (!filters.SEXO || row.SEXO === filters.SEXO)
    );

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [filters, datos]);
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Estad&iacute;sticos Ingreso albergues</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Ingreso albergues</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativos/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-header' style={{display: 'flex', justifyContent: 'flex-end', textAlign: 'right',}}> 
                                    <ButtonsMenu data={filteredData} titulo={'Informe ayudas'} exportarCSV={exportarCSV} exportaExcel={exportaExcel}/>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Container>
                                            <ButtonGroup aria-label="Basic example">
                                                <label htmlFor="FechaInicial">
                                                    <Controller
                                                        control={control}
                                                        name="FechaInicial"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                id="FechaInicial"
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    /></label>
                                                    {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                                
                                                <label htmlFor="FechaFinal">
                                                    <Controller
                                                        control={control}
                                                        name="FechaFinal"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                id="FechaFinal"
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />{errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                                </label>                                                
                                                <button
                                                    type="submit"
                                                    className="img-square elevation-1"
                                                    style={{
                                                        fontSize: '0.7rem',
                                                        padding: '2px 12px',
                                                        height: 38,
                                                        minWidth: '80px',
                                                        verticalAlign: 'middle',
                                                        border: '1px solid #6daff1ff',
                                                        borderRadius: 4,
                                                        background: '#abbdcfff',
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Consultar"
                                                >
                                                    <FaSearch /> Buscar
                                                </button>
                                            </ButtonGroup>
                                        </Container>
                                    </form>
                                </div>
                                
                                {datos && datos.length > 0 && <div className="card-body table-responsive p-0">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0' }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Anterior
                                        </button>
                                        <span style={{ margin: '0 1rem' }}>
                                            Página {currentPage} de {totalPages}
                                        </span>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Tipo documento</th>
                                                <th>Identificacion</th>
                                                <th>Primer Nombre</th>
                                                <th>Segundo Nombre</th>
                                                <th>Primer Apellido</th>
                                                <th>Segundo Apellido</th>
                                                <th>Fecha Nacimiento</th>
                                                <th>Sexo</th>
                                                <th>Orientación Sexual</th>
                                                <th>Identidad de Género</th>
                                                <th>Etnia</th>
                                                <th>Discapacidad</th>
                                                <th>Hecho Victimizante</th>
                                                <th>Habitante Calle</th>
                                                <th>Campesino</th>
                                                <th>Escolaridad</th>
                                                <th>Régimen Afiliación Salud</th>
                                                <th>Estrato Socioeconómico</th>
                                                <th>Zona</th>
                                                <th>Área</th>
                                                <th>Barrio</th>
                                                <th>Comuna</th>
                                                <th>Fecha Ingreso Programa</th>
                                                <th>País Nacimiento</th>
                                                <th>Cabeza de Familia</th>
                                                <th>Parentesco</th>
                                                <th>Fecha Salida Programa</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.SEXO}
                                                        onChange={e => setFilters(f => ({ ...f, SEXO: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datos.map(row => row.SEXO).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((row) => {
                                                return (
                                                    <tr key={`${row.DOCUMENTO || 'sin-doc'}-${row.FECHAINGRESOPROGRAMA || 'sin-fecha'}-${row.PARENTESCO || 'sin-parentesco'}`}>
                                                        <td>{row.TIPODOCUMENTO}</td>
                                                        <td>{row.DOCUMENTO}</td>
                                                        <td>{row.PRIMERNOMBRE}</td>
                                                        <td>{row.SEGUNDONOMBRE}</td>
                                                        <td>{row.PRIMERAPELLIDO}</td>
                                                        <td>{row.SEGUNDOAPELLIDO}</td>
                                                        <td>{row.fechanacimiento}</td>
                                                        <td>{row.SEXO}</td>
                                                        <td>{row.orientacionsexual}</td>
                                                        <td>{row.identidadgenero}</td>
                                                        <td>{row.ETNIA}</td>
                                                        <td>{row.DISCAPACIDAD}</td>
                                                        <td>{row.HECHOVICTIMIZANTE}</td>
                                                        <td>{row.habitantecalle}</td>
                                                        <td>{row.campesino}</td>
                                                        <td>{row.ESCOLARIDAD}</td>
                                                        <td>{row.regimenafiliacionsalud}</td>
                                                        <td>{row.estratosocioeconomico}</td>
                                                        <td>{row.ZONA}</td>
                                                        <td>{row.area}</td>
                                                        <td>{row.BARRIO}</td>
                                                        <td>{row.COMUNA}</td>
                                                        <td>{row.fechaingresoprograma}</td>
                                                        <td>{row.paisnacimiento}</td>
                                                        <td>{row.CABEZAFAMILIA}</td>
                                                        <td>{row.PARENTESCO}</td>
                                                        <td>{row.fechasalidaprograma}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}